import React from "react";
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {
    BottomNavigation,
    BottomNavigationAction,
    Grid,
    Hidden
} from "@material-ui/core";

import navItems from "./navItems";
import {setActiveLink} from "../../vendors/actions/layout";

interface ConnectStateProps {
    Layout: any
}

interface ConnectDispatchProps {
    setActiveLink?: (data: any) => void;
}

const MobileNavBar = (props: any) => {
    const {history} = props,
        {activeLink} = props.Layout;

    const handleChange = (event: any, newValue: 'string') => {
        console.log("history", history)
        console.log(newValue)
        props.setActiveLink(newValue);
        history.push(newValue);
    };
    return (
        <Hidden lgUp>
            <Grid className='mobile-navbar' item xs={12}>
                <BottomNavigation showLabels className='mobile-navbar-item' value={activeLink} onChange={handleChange}>
                    {navItems.map((item: any, key) =>
                        <BottomNavigationAction
                            key={key}
                            label={item.label}
                            value={item.to}
                            icon={<item.icon className={`mobile-navbar-icon ${item.className}`}/>}
                        />)}
                </BottomNavigation>
            </Grid>
        </Hidden>
    )
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, object>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Layout} = state;
    return {Layout}
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, object>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        setActiveLink: (data: any) => dispatch(setActiveLink(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileNavBar);


